<template>
  <div class="cmpt-purchase-order-edit-modal">
    <el-button type="primary" @click="openModal">编辑采购单</el-button>

    <el-dialog title="编辑采购单" :visible.sync="modalVisible" width="50%">
      <el-form inline :model="form">
        <div
          class="items item-box"
          v-for="item in form.purchase_order.items"
          :key="item.id"
        >
          <el-form-item label="SKU">
            <el-input :value="item.sku" disabled />
          </el-form-item>

          <el-form-item label="数量">
            <el-input v-model="item.qty" />
          </el-form-item>

          <!-- <el-form-item label="单价">
            <el-input v-model="item.price" />
          </el-form-item> -->
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class ManufactureEditModal extends Vue {
    @Prop(Object) row

    form = {
      purchase_order: {}
    }

    @Watch('modalVisible')
    initForm(newVisible, oldVisible) {
      if (oldVisible !== newVisible && newVisible) {
        this.form.purchase_order = _.cloneDeep(this.row.purchase_order);
      }
    }
    mounted() {
      this.initForm();
    }

    modalVisible = false
    openModal() {
      this.modalVisible = true;
    }
    closeModal() {
      this.modalVisible = false;
    }

    async handleSubmit() {
      const params = {
        purchase_order: {
          id: this.form.purchase_order.id,
          items: this.form.purchase_order.items.map(item => ({
            id: item.id,
            sku: item.sku,
            qty: item.qty,
            // price: item.price
          }))
        }
      };
      await this.$autoLoading(this.$request.put(`/orders/${this.row.id}/update_purchase_order`, params));
      this.closeModal();
      this.$emit('reload');
      this.$message.success(this.$t('operateSuccess'));
    }
  }
</script>

<style lang="scss" scoped>
  .item-box {
    padding: 10px;
    border: 1px solid #ddd;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.items {
      margin-left: 0;
    }
  }

  .label-text {
    font-weight: bold;
  }
</style>
